import React from 'react';
import { Card, CardHeader } from '../../ui/Card';

function formatDate(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Ukjent dato';

  return new Intl.DateTimeFormat('nb-NO', {
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(date);
}

export function AcademyAdminActivity({ activity }) {
  return (
    <Card>
      <CardHeader
        title="Nylig deltakeraktivitet"
        subtitle="De siste registrerte påmeldingene, fullføringene og kursbevisene"
      />
      {activity.length === 0 ? (
        <p className="p-6 text-sm text-slate-500">Ingen deltakeraktivitet er registrert.</p>
      ) : (
        <ol className="divide-y divide-slate-100">
          {activity.map((item, index) => (
            <li
              key={`${item.type}-${item.date}-${index}`}
              className="flex flex-col gap-1 px-6 py-4 sm:flex-row sm:items-center sm:justify-between"
            >
              <div>
                <p className="font-semibold text-slate-800">{item.type}</p>
                <p className="mt-1 text-sm text-slate-600">
                  {item.learner} · {item.course}
                </p>
              </div>
              <time
                dateTime={item.date}
                className="text-xs text-slate-500 sm:text-right"
              >
                {formatDate(item.date)}
              </time>
            </li>
          ))}
        </ol>
      )}
    </Card>
  );
}